import type { OnDropCallback } from '@/addPanelInfra';
import type { EditorAPI } from '@/editorAPI';
import type { PresetSectionItem } from '@wix/add-panel-component';
import type { CompStructure } from 'types/documentServices';
import { addCompOnClick, addCompOnDrop } from './addComp';

interface AddPricingPlansOnClickParams {
  appDefinitionId: string;
  widgetId: string;
  compStructure: CompStructure;
  tags: string;
  itemId: string;
  sectionTitle: string;
  categoryId: string;
  biOrigin: string;
  position: { x: number; y: number } | void;
}

export const addPricingPlansOnClick = (
  editorAPI: EditorAPI,
  {
    appDefinitionId,
    widgetId,
    compStructure,
    tags,
    itemId,
    sectionTitle,
    categoryId,
    biOrigin,
    position,
  }: AddPricingPlansOnClickParams,
) => {
  return addCompOnClick(editorAPI, {
    appDefinitionId,
    widgetId,
    compStructure,
    tags,
    itemId,
    sectionTitle,
    categoryId,
    biOrigin,
    position,
  });
};

interface AddPricingPlansOnDropParams {
  item: PresetSectionItem;
  appDefinitionId: string;
  widgetId: string;
  biOrigin: string;
}

export const addPricingPlansOnDrop = (
  editorAPI: EditorAPI,
  { appDefinitionId, widgetId, biOrigin }: AddPricingPlansOnDropParams,
): OnDropCallback => {
  return addCompOnDrop(editorAPI, {
    appDefinitionId,
    widgetId,
    biOrigin,
  });
};
